import { engineComponent, NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { UserControls } from "../Common/UserControls/UserControls";
import { RouletteController } from "../../GameComponents/Roulette/RouletteController";
import { PlayList } from "../../Components/Sounds/PlayList";
import { RouletteActions } from "../Common/Actions/RouletteActions";
import { RouletteBetConfiguration } from "../../CustomComponents/RouletteBetConfiguration";
import { ResponsibleDialog1 } from "../Common/Dialogs/ResponsibleDialog1";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { BetManager } from "../../Managers/BetManager";
import { Racetrack } from "../../GameComponents/Racetrack";
import { BalanceManager } from "../../Managers/BalanceManager";
import { GameData } from "../Common/Datas/GameData";
import { DataManager } from "../../Managers/DataManager";
import { FreeRoundBonus } from "../Common/Bonuses/FreeRoundBonus";
import { GameManager } from "../../Managers/GameManager";
import { GameActions } from "../Common/Actions/GameActions";
import { Paytable } from "../Common/Paytable/Paytable";
import { HtmlToastMessage } from "../../HTMLComponents/Elements/HtmlToastMessage";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { AppContext } from "../../../Common/AppContext";
import { Statistics } from "../Common/Statistics/Statistics";
import { HtmlNumberHistory } from "../../HTMLComponents/Custom/HtmlNumberHistory";
import { Jackpot } from "../Common/Bonuses/Jackpot";
import { HtmlSchemasContainerElement } from "../../CustomComponents/HtmlSchemasContainerElement";
import { Bet } from "../../GameComponents/Bet";
import { StatisticsManager } from "../../Managers/StatisticsManager";
import { CustomUtils } from "../../Utils/CustomUtils";
import { Languages } from "../../Utils/Languages";
import { LimitDialog } from "../Common/Dialogs/LimitDialog";
import { ModuleManager } from "../../Managers/ModuleManager";
import { FreeRoundBonusDialog } from "../Common/Dialogs/FreeRoundBonusDialog";

var GameModules = Communication.Game.GameModules;

@engineComponent(ComponentTypes.HtmlElement)
export class MobileRouletteUserControls extends UserControls {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected _controller: RouletteController;

    private _userControls: HTMLElement;

    private _betActions: Array<string>;

    private _racetrackActions: Array<string>;

    private _chipSelectorActions: Array<string>;

    private _spinWithoutBetEnabled: boolean;

    private _paytable: Paytable;

    private _statistics: Statistics;

    private _numberHistory: HtmlNumberHistory;

    private _autoplayDelay: FrameTimerEventEmitter;

    private _stopBtnReady: boolean;

    private _stopBtnDelay: FrameTimerEventEmitter;

    private _quickStopEnabled: boolean;

    private _racetrackActive: boolean;

    private _schemas: HtmlSchemasContainerElement;

    private _spinStartDelay: FrameTimerEventEmitter;

    //******************************************************************************************************************
    //  CONSTRUCTOR CREATE
    //******************************************************************************************************************

    constructor() {
        super("roulette");
    }

    create(node: Element): void {
        super.create(node);

        this.registerActions();
        this.registerBetActions();
        this.registerRacetrackActions();

        this._autoplayDelay = CreateFrameTimer("autoplayDelay");
        this._autoplayDelay.on(FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));

        this._stopBtnDelay = CreateFrameTimer("stopBtnDelay");
        this._stopBtnDelay.on(FrameTimerEvents.Complete, this.activateStopBtn.bind(this));

        this._spinStartDelay = CreateFrameTimer("spinStartDelay");
        this._spinStartDelay.on(FrameTimerEvents.Complete, this.spinStartDelayed.bind(this));

        this._userControls = document.getElementById("userControls");

        this._racetrackActive = false;
    }

    addController(controller: RouletteController): void {
        this._controller = controller;

        this._controller.on(RouletteController.SpinReceived, this.spinReceived.bind(this));
        this._controller.on(RouletteController.WheelStopped, this.wheelStopped.bind(this));
        this._controller.on(RouletteController.WinCalculationFinished, this.winCalculationFinished.bind(this));
        this._controller.on(RouletteController.AllWinsFinished, this.allWinsFinished.bind(this));
    }

    //******************************************************************************************************************
    //  REGISTER ACTIONS
    //******************************************************************************************************************

    registerActions(): void {
        this.actions.registerActions({
            [RouletteActions.ActionAutoplay]: false,
            [RouletteActions.ActionSchemasToggle]: false,
            [RouletteActions.ActionStatisticsToggle]: false,
            [RouletteActions.ActionAutoplayStop]: false,
            [RouletteActions.ActionSpin]: false,
            [RouletteActions.ActionSpinStop]: false,
            [RouletteActions.ActionDouble]: false,
            [RouletteActions.ActionRebet]: false,
            [RouletteActions.ActionBetBack]: false,
            [RouletteActions.ActionBetReset]: false,
            [RouletteActions.ActionRacetrackNeighboursPlus]: false,
            [RouletteActions.ActionRacetrackNeighboursMinus]: false,
            [RouletteActions.ActionRacetrackToggle]: false,
            [RouletteActions.ActionRacetrackOff]: false,
            [RouletteActions.ActionSchemasPlayerSelect]: false,
            [RouletteActions.ActionSchemasDefaultSelect]: false,
            [RouletteActions.ActionSchemasDelete]: false,
            [RouletteActions.ActionSchemasSwitch]: false,
        });
    }

    registerBetActions(): void {
        this._betActions = [];
        let actions = {};

        for (let i = 0; i < RouletteBetConfiguration.AllTypes.length; i++) {
            let type = <Array<number>>RouletteBetConfiguration[RouletteBetConfiguration.AllTypes[i]];

            for (let j = 0; j < type.length; j++) {
                let betAction = RouletteActions["ActionBet" + RouletteBetConfiguration.AllTypes[i]] + type[j];
                actions[betAction] = false;

                this._betActions.push(betAction);
            }
        }

        this.actions.registerActions(actions);
    }

    registerRacetrackActions(): void {
        this._racetrackActions = [];
        let actions = {};

        for (let i = 0; i < RouletteBetConfiguration.RacetrackAllTypes.length; i++) {
            let betAction = RouletteBetConfiguration.RacetrackAllTypes[i];

            if (betAction == "R_") {
                for (let j = 0; j < 37; j++) {
                    betAction = "R_" + j;
                    actions[betAction] = false;
                    this._racetrackActions.push(betAction);
                }
            } else {
                actions[betAction] = false;
                this._racetrackActions.push(betAction);
            }
        }

        this.actions.registerActions(actions);
    }

    registerChipSelectorActions(): void {
        this._chipSelectorActions = [];
        let actions = {};

        for (let i = 0; i < BetManager.Chips.length; i++) {
            let action = RouletteActions.ActionBetSelectValue + i;
            actions[action] = false;
            this._chipSelectorActions.push(action);
        }

        this.actions.registerActions(actions);
    }

    //******************************************************************************************************************
    //  RESPONSE RECEIVED
    //******************************************************************************************************************

    initReceived(): void {
        super.initReceived();

        this._paytable = new Paytable();
        this._paytable.initialize();

        this._statistics = new Statistics();

        if (HtmlController.ContainerElementsById[HtmlNumberHistory.ElementId] != null) {
            this._numberHistory = <HtmlNumberHistory>HtmlController.ContainerElementsById[HtmlNumberHistory.ElementId];
        }

        if (HtmlController.ContainerElementsById[HtmlSchemasContainerElement.ElementId] != null) {
            this._schemas = <HtmlSchemasContainerElement>(
                HtmlController.ContainerElementsById[HtmlSchemasContainerElement.ElementId]
            );
        }

        this.registerChipSelectorActions();

        this._controller.initReceived();

        if (GameManager.rouletteResponse && GameManager.rouletteResponse.initData) {
            this._spinWithoutBetEnabled = GameManager.rouletteResponse.initData.spinWithoutBetEnabled;

            this._statistics.update(GameManager.rouletteResponse.statistics);

            if (this._numberHistory != null) {
                this._numberHistory.initialize(GameManager.rouletteResponse.statistics);
            }
        }
    }

    restoreGameRound(): void {
        FreeRoundBonus.enableUi();
        this.prepareNewGameRound();
    }

    spinReceived(): void {
        if (DataManager.quickspinEnabled()) {
            this.actions.changeActionState(RouletteActions.ActionSpinStop, false);
            HtmlController.updateActionElements(this.getAllActions());
            HtmlController.dispatchUiAction("");
            DataManager.updateDataElement(GameData.DataRoundId);
            this._quickStopEnabled = true;
            this.activateStopBtn();
        } else {
            this.activateStopBtn();
            HtmlController.updateActionElements(this.getAllActions());
            DataManager.updateDataElement(GameData.DataRoundId);
        }
    }

    private activateStopBtn(): void {
        if (this._stopBtnReady) {
            if (this._quickStopEnabled) {
                this._controller.stop();
            } else {
                this.actions.changeActionState(
                    RouletteActions.ActionSpinStop,
                    AppContext.gameConfiguration.GameEnableReelsStop,
                );
                HtmlController.updateActionElement(
                    RouletteActions.ActionSpinStop,
                    AppContext.gameConfiguration.GameEnableReelsStop,
                );
            }
        } else {
            this._stopBtnReady = true;
        }
    }

    //******************************************************************************************************************
    //  BASE ACTIONS
    //******************************************************************************************************************

    dispatchAction(action: string): void {
        LimitDialog.closeDialog();
        if (action === GameActions.ActionSpinOrStop) {
            if (this.actions.getActionState(RouletteActions.ActionRebet)) {
                action = RouletteActions.ActionRebet;
            } else if (this.actions.getActionState(RouletteActions.ActionSpin)) {
                action = RouletteActions.ActionSpin;
            } else if (this.actions.getActionState(RouletteActions.ActionSpinStop)) {
                action = RouletteActions.ActionSpinStop;
            } else {
                return;
            }
        }

        if (this.actions.getActionState(action)) {
            super.dispatchAction(action);

            if (this._betActions.indexOf(action) > -1) {
                this.placeGridBet(action);
                PlayList.play("SND_BaseChipsDrop");
            } else if (this._racetrackActions.indexOf(action) > -1) {
                this.placeRacetrackBet(action);
                PlayList.play("SND_BaseChipsDrop");
            } else if (action.indexOf(RouletteActions.ActionBetSelectValue) == 0) {
                this.changeBetByIndex(action);
                PlayList.play("SND_BaseChipsDrop");
            } else {
                PlayList.play("SND_Click");
                switch (action) {
                    case RouletteActions.ActionSpin:
                        this.spin();
                        break;
                    case RouletteActions.ActionSpinStop:
                        this.stop();
                        break;
                    case RouletteActions.ActionAutoplay:
                        this.autoplay();
                        break;
                    case RouletteActions.ActionAutoplayStop:
                        this.autoplayStop();
                        break;
                    case RouletteActions.ActionSchemasToggle:
                        this.schemasToggle();
                        break;
                    case RouletteActions.ActionDouble:
                        this.doubleBet();
                        break;
                    case RouletteActions.ActionRebet:
                        this.rebet();
                        break;
                    case RouletteActions.ActionBetBack:
                        this.betBack();
                        break;
                    case RouletteActions.ActionBetReset:
                        this.betReset();
                        break;
                    case RouletteActions.ActionRacetrackNeighboursPlus:
                        this.changeRacetrackNeighbours(false);
                        break;
                    case RouletteActions.ActionRacetrackNeighboursMinus:
                        this.changeRacetrackNeighbours(true);
                        break;
                    case RouletteActions.ActionRacetrackToggle:
                        this.racetrackToggle();
                        break;
                    case RouletteActions.ActionRacetrackOff:
                        //currently active only when racetrack is ON
                        this.racetrackToggle();
                        break;
                    case RouletteActions.ActionSchemasDelete:
                        this.schemaDelete();
                        break;
                    case RouletteActions.ActionSchemasPlayerSelect:
                        this.schemaSelect(true);
                        break;
                    case RouletteActions.ActionSchemasDefaultSelect:
                        this.schemaSelect();
                        break;
                    case RouletteActions.ActionSchemasSwitch:
                        this.schemaSwitch();
                        break;
                    case RouletteActions.ActionStatisticsToggle:
                        this.statisticsToggle();
                        break;
                }
            }
        }
    }

    spin(fromAutoplay: boolean = false): void {
        if (!BetManager.hasPlacedBet()) {
            HtmlToastMessage.show(
                Languages.getRid("ERROR_PLACE_BET"),
                HtmlToastMessage.Position.middle,
                "toastMessageHolder",
            );
            return;
        }

        HtmlToastMessage.removeAllToastMessages();
        this.disableSchemas();

        FreeRoundBonus.disableUi();
        if (FreeRoundBonus.hasNewActiveOffer()) {
            if (GameManager.gameResponse.totalWin > 0 && !DataManager.GameRoundClosed) {
                this.changeWinBox(true);
                this.collect();
            } else {
                FreeRoundBonus.enableUi();
            }
            return;
        }
        this._quickStopEnabled = false;

        if (this.checkJackpotMiniGame()) {
            return;
        }

        if (this._userControls != null) {
            this._userControls.classList.add("inSpin");
        }

        if (!BalanceManager.hasCredit()) {
            DataManager.Autoplay = false;
            DataManager.GameLimit = false;
            this.prepareNewGameRound();
            return;
        }

        if (ResponsibleDialog1.showResponsibleDialog1OnCollect) {
            GameManager.canExit();
            this.changeWinBox();

            return;
        }

        if (Paytable.shouldOpen(true, true)) {
            Paytable.show();
            return;
        }

        //there must be min 30f delay between spin and activating stopbtn
        this._stopBtnReady = false;
        this._stopBtnDelay.start(31);

        FreeRoundBonus.disableUi();
        this.actions.disableAllActions();

        if (DataManager.Autoplay) {
            if (
                GameManager.rouletteResponse != null &&
                GameManager.rouletteResponse.totalWin != null &&
                GameManager.rouletteResponse.totalWin > 0
            ) {
                DataManager.updateLossLimit(GameManager.rouletteResponse.totalWin);
            }
            DataManager.updateLossLimit();
            this.actions.changeActionState(
                RouletteActions.ActionAutoplayStop,
                AppContext.gameConfiguration.AutoplayModeEnabled,
            );
        }

        HtmlController.dispatchUiAction("");
        HtmlController.updateActionElements(this.getAllActions());

        if (fromAutoplay) {
            this._spinStartDelay.stop();
            this._spinStartDelay.start(30);
            return;
        }

        DataManager.Collectable = false;
        BalanceManager.fixBalance();
        this._controller.spin();

        Platforms.Platforms.roundStarted({
            totalBet: BetManager.Bet,
            freeRound: FreeRoundBonus.inFrb,
            userAction: DataManager.getTrustedUserAction(RouletteActions.ActionSpin),
        });
        Platforms.Platforms.spinStarted();
        Platforms.Platforms.balanceUpdated({ amount: parseFloat(DataManager.getDataById(GameData.DataBalanceTotal)) });
    }

    private spinStartDelayed(): void {
        this._spinStartDelay.stop();
        DataManager.Collectable = false;
        BalanceManager.fixBalance();
        this._controller.spin();
    }

    stop(): void {
        this.actions.changeActionState(RouletteActions.ActionSpinStop, false);
        HtmlController.updateActionElements(this.getAllActions());
        HtmlController.dispatchUiAction("");
        DataManager.quickspinStopped();
        this._controller.stop();
    }

    changeBet(decrease: boolean): void {
        if (decrease) {
            BetManager.moveChipSelectorToLeft();
        } else {
            BetManager.moveChipSelectorToRight();
        }

        this._controller.changeBet();
    }

    changeBetByIndex(action: string): void {
        let index = parseInt(action.replace(RouletteActions.ActionBetSelectValue, ""));
        BetManager.changeBetByIndex(index);
    }

    betBack(): void {
        let roulletBets = BetManager.revertLastBet();

        for (let i = 0; i < roulletBets.length; i++) {
            this._controller.placeGridBet(roulletBets[i]);
        }

        this.resetSchemas();
        this.enableGameButtons(BetManager.hasPlacedBet());
        this.updateTableCoverage();

        CustomUtils.incrementActionCount(RouletteActions.ActionBetBack);
    }

    betReset(): void {
        BetManager.resetBets();
        this._controller.resetBets();

        this.resetSchemas();
        this.enableGameButtons(false);
        this.updateTableCoverage();

        CustomUtils.incrementActionCount(RouletteActions.ActionBetReset);
    }

    changeRacetrackNeighbours(decrease: boolean): void {
        if (decrease) {
            Racetrack.neighboursMinus();
        } else {
            Racetrack.neighboursPlus();
        }

        this.actions.changeActionState(
            RouletteActions.ActionRacetrackNeighboursPlus,
            Racetrack.hasNextNeighbourOption(),
        );
        HtmlController.updateActionElement(
            RouletteActions.ActionRacetrackNeighboursPlus,
            Racetrack.hasNextNeighbourOption(),
        );
        this.actions.changeActionState(
            RouletteActions.ActionRacetrackNeighboursMinus,
            Racetrack.hasPreviousNeighbourOption(),
        );
        HtmlController.updateActionElement(
            RouletteActions.ActionRacetrackNeighboursMinus,
            Racetrack.hasPreviousNeighbourOption(),
        );
    }

    racetrackToggle(): void {
        let racetrackBtn = document.getElementById("racetrackToggleBtn");
        let racetrackControls = document.getElementById("racetrackControls");

        if (racetrackBtn != null && racetrackControls != null) {
            if (this._racetrackActive) {
                racetrackBtn.classList.remove("_active");
                racetrackControls.classList.remove("_active");
                this.actions.changeActionStates(this.getBetActionsWithState(true));
                HtmlController.updateActionElements(this.getBetActionsWithState(true));
                this._controller.racetrackToggle(false);
                this._racetrackActive = false;
            } else {
                this.disableSchemas();
                racetrackBtn.classList.add("_active");
                racetrackControls.classList.add("_active");
                this.actions.changeActionStates(this.getBetActionsWithState(false));
                HtmlController.updateActionElements(this.getBetActionsWithState(false));
                this._controller.racetrackToggle(true);
                this._racetrackActive = true;
            }

            this.actions.changeActionState(RouletteActions.ActionRacetrackOff, this._racetrackActive);
            HtmlController.updateActionElement(RouletteActions.ActionRacetrackOff, this._racetrackActive);
        }
    }

    private updateActionsByRacetrack(): void {
        if (this._racetrackActive) {
            this.actions.changeActionStates(this.getBetActionsWithState(false));
            HtmlController.updateActionElements(this.getBetActionsWithState(false));

            this.actions.changeActionState(RouletteActions.ActionRacetrackOff, true);
            HtmlController.updateActionElement(RouletteActions.ActionRacetrackOff, true);
        }
    }

    //******************************************************************************************************************
    //  SCHEMAS
    //******************************************************************************************************************

    schemasToggle(): void {
        if (this._racetrackActive) {
            this.racetrackToggle(); //turn off racetrack
        }

        if (this._schemas != null) {
            this._schemas.toggleEnable();
        }

        this._controller.resetSchemaBets();
        this._controller.schemasToggle();
    }

    disableSchemas(): void {
        if (this._schemas != null) {
            this._schemas.setEnable(false);
        }

        this._controller.resetSchemaBets();
    }

    private schemaSelect(playerSchema: boolean = false): void {
        if (this._schemas != null) {
            let bets = this._schemas.getSelectedSchemeBets(playerSchema);
            let previewBets = this._schemas.selectScheme(BetManager.getPlacedBets(), playerSchema);
            let onlySchemaBets = this._schemas.selectScheme([], playerSchema);
            let hasPreviewBets = false;
            let totalBet = onlySchemaBets.reduce((a: number, b: Bet) => parseInt(NumberUtils.add(a, b.value)), 0);
            this._controller.resetSchemaBets();

            //check max table limit
            if (BetManager.schemaBetReachedMaxTableLimit(totalBet)) {
                this.handleMaxTableBetLimitError();
                return;
            }

            //check single bet limit for all bets
            let limitedBetIds = BetManager.schemaBetReachedSingleBetLimit(onlySchemaBets);
            if (limitedBetIds.length > 0) {
                this.handleMultipleSingleBetLimitError();
                return;
            }

            for (let i = 0; i < bets.length; i++) {
                let key = bets[i].type + "_" + bets[i].selection;
                this.placeGridBet(key, i != 0, bets[i].value);
            }

            if (previewBets != null && previewBets.length > 0) {
                hasPreviewBets = true;
                for (let i = 0; i < previewBets.length; i++) {
                    this._controller.placeSchemaBet(previewBets[i]);
                }
                this._controller.updateSchemaPossibleWins(previewBets);
            }

            this.updateSchemaButtons(hasPreviewBets, playerSchema);
            CustomUtils.incrementActionCount(
                playerSchema ? RouletteActions.ActionSchemasPlayerSelect : RouletteActions.ActionSchemasDefaultSelect,
            );
        }
    }

    private schemaDelete(): void {
        if (this._schemas != null) {
            this._schemas.deleteSchema();
            this._controller.resetSchemaBets();
            this.updateSchemaButtons(false);
        }
    }

    private schemaSwitch(): void {
        if (this._schemas != null) {
            this._schemas.switchSchemas();
            this._controller.resetSchemaBets();
            this.updateSchemaButtons(false);
        }
    }

    private resetSchemas(): void {
        if (this._schemas != null) {
            DataManager.SchemaSelected = -1;
            this._schemas.selectScheme([], false);
            this._controller.resetSchemaBets();
            this.updateSchemaButtons(false);
        }
    }

    //******************************************************************************************************************
    //  STATISTICS
    //******************************************************************************************************************

    private statisticsToggle(): void {
        StatisticsManager.toggleStatistics();

        CustomUtils.incrementActionCount(RouletteActions.ActionStatisticsToggle);
    }

    //******************************************************************************************************************
    //  BET PLACE ACTIONS
    //******************************************************************************************************************

    private placeGridBet(betPlaceId: string, grouped: boolean = false, customValue: number = -1): void {
        if (this.hasTableErrors(betPlaceId, customValue)) {
            return;
        }

        let roulletBet = BetManager.placeBet(betPlaceId, grouped, customValue);
        if (roulletBet) {
            this._controller.placeGridBet(roulletBet);
        }

        this.clearTotalWin();
        this.enableGameButtons(true);
        this.updateTableCoverage();

        //disable rebet after first chip was placed
        this.actions.changeActionState(RouletteActions.ActionRebet, false);
        HtmlController.updateActionElement(RouletteActions.ActionRebet, false);
    }

    private placeRacetrackBet(racetrackId: string): void {
        let betPlaceIds = Racetrack.getBetsByRacetrackId(racetrackId);

        //check max table limit
        if (BetManager.racetrackReachedMaxTableLimit(betPlaceIds.length)) {
            this.handleMaxTableBetLimitError();
            return;
        }

        //check single bet limit for all bets
        let limitedBetIds = BetManager.racetrackReachedSingleBetLimit(betPlaceIds);
        if (limitedBetIds.length > 0) {
            this.handleMultipleSingleBetLimitError();
            return;
        }

        //if no errors, place every single bet
        for (let i = 0; i < betPlaceIds.length; i++) {
            this.placeGridBet(betPlaceIds[i], i != 0); //first bet create history checkpoint, others bets are added to checkpoint
        }

        CustomUtils.incrementActionCount("RACETRACK_BET");
    }

    doubleBet(): void {
        this.resetSchemas();

        //check max table limit
        if (BetManager.doubleBetReachedMaxTableLimit()) {
            this.handleMaxTableBetLimitError();
            return;
        }

        //check single bet limit for all bets
        let limitedBetIds = BetManager.doubleBetReachedSingleBetLimit();
        if (limitedBetIds.length > 0) {
            this.handleMultipleSingleBetLimitError();
            return;
        }

        //if no errors, place every single bet
        let bets = BetManager.placeDoubleBet();
        for (let i = 0; i < bets.length; i++) {
            if (bets[i]) {
                this._controller.placeGridBet(bets[i]);
            }
        }

        CustomUtils.incrementActionCount(RouletteActions.ActionDouble);
    }

    rebet(): void {
        let bets = BetManager.placeLastBets();

        for (let i = 0; i < bets.length; i++) {
            if (bets[i]) {
                this._controller.placeGridBet(bets[i]);
            }
        }

        //disable rebet after first chip was placed
        this.actions.changeActionState(RouletteActions.ActionRebet, false);
        HtmlController.updateActionElement(RouletteActions.ActionRebet, false);

        this.clearTotalWin();
        this.enableGameButtons(true);
        this.updateTableCoverage();

        CustomUtils.incrementActionCount(RouletteActions.ActionRebet);
    }

    //******************************************************************************************************************
    //  AUTOPLAY
    //******************************************************************************************************************

    autoplayDelayed(): void {
        this._autoplayDelay.stop();
        if (DataManager.Autoplay) {
            this.autoplay();
        } else {
            this.prepareNewGameRound();
        }
    }

    autoplay(): void {
        if (this.checkJackpotMiniGame()) {
            return;
        }

        if (DataManager.AutoplayCount === "∞") {
            DataManager.Autoplay = true;
            DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);

            //if we dont have any placed bets, just rebet
            if (!BetManager.hasPlacedBet()) {
                this.rebet();
            }

            this.spin(true);
        } else {
            DataManager.AutoplayCount = (parseInt(DataManager.AutoplayCount) - 1).toString();
            if (parseInt(DataManager.AutoplayCount) >= 0) {
                DataManager.Autoplay = true;
                DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);

                //if we dont have any placed bets, just rebet
                if (!BetManager.hasPlacedBet()) {
                    this.rebet();
                }

                this.spin(true);
            } else {
                DataManager.Autoplay = false;
                this.prepareNewGameRound();
            }
        }
    }

    autoplayStop(): void {
        DataManager.Autoplay = false;

        Platforms.Platforms.autoplayStop();

        this.actions.changeActionState(RouletteActions.ActionAutoplayStop, false);
        HtmlController.updateActionElement(RouletteActions.ActionAutoplayStop, false);

        this._controller.autoplayStop();
    }

    //******************************************************************************************************************
    //  GAME STATES
    //******************************************************************************************************************

    wheelStopped(): void {
        if (this._statistics != null) {
            this._statistics.update(GameManager.rouletteResponse.statistics);
        }

        if (this._numberHistory != null) {
            this._numberHistory.update(GameManager.rouletteResponse.statistics);
        }

        Platforms.Platforms.spinEnded();

        if (DataManager.Autoplay) {
            if (DataManager.AutoplayCount === 0 + "") {
                DataManager.Autoplay = false;
            }
        }

        this.actions.changeActionState(RouletteActions.ActionSpinStop, false);
        HtmlController.updateActionElement(RouletteActions.ActionSpinStop, false);
    }

    winCalculationFinished(): void {
        if (GameManager.rouletteResponse != null && GameManager.rouletteResponse.totalWin > 0) {
            Platforms.Platforms.win(GameManager.rouletteResponse.totalWin);
        }
    }

    allWinsFinished(): void {
        if (DataManager.GameRoundClosed) {
            DataManager.updateDataElements();
        }

        Platforms.Platforms.roundEnded({
            id: GameManager.gameResponse.roundId,
            win: GameManager.gameResponse.totalWin,
            balanceAfter: parseFloat(DataManager.getDataById(GameData.DataBalanceTotal)),
        });

        DataManager.updateDataElement(GameData.DataTotalWin);
        this.playCollectSound();

        this.betReset();

        DataManager.Collectable = true;
        FreeRoundBonus.enableUi();

        DataManager.updateDataElements();

        if (DataManager.Autoplay) {
            this._autoplayDelay.start(30);
            this.actions.disableAllActions();
            HtmlController.updateActionElements(this.getAllActions());
        } else {
            this.prepareNewGameRound();
            this.updateActionsByRacetrack();
        }

        CustomUtils.sendRouletteActionsData();
    }

    initIntro(): void {
        super.initIntro();

        this._controller.initIntro();
        this.prepareNewGameRound();
        this.updateTableCoverage();
        ModuleManager.disableBase();
        //disable rebet in init ToDo preco ma byt rebet na zaciatku disabled ?
        //HtmlController.updateActionElement(RouletteActions.ActionRebet, false);
    }

    //******************************************************************************************************************
    //  NEW GAME ROUND
    //******************************************************************************************************************

    prepareNewGameRound(): void {
        if (this.prepareJackpotMiniGame()) {
            return;
        }

        if (ResponsibleDialog1.opened || FreeRoundBonusDialog.opened) {
            return;
        }

        Paytable.openAtStart(true);

        if (DataManager.GameLimit) {
            this.limit();
        }
        if (!DataManager.Autoplay) {
            if (this._userControls != null) {
                this._userControls.classList.remove("inSpin");
            }

            this.actions.changeActionStates(this.getBetActionsWithState(true));
            this.actions.changeActionStates(this.getRacetrackActionsWithState(true));
            this.actions.changeActionStates(this.getChipSelectorActionsWithState(true));

            this.actions.changeActionStates({
                [RouletteActions.ActionAutoplay]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionAutoplayStop]: false,
                [RouletteActions.ActionSchemasToggle]: true,
                [RouletteActions.ActionStatisticsToggle]: true,
                [RouletteActions.ActionSpin]: true,
                [RouletteActions.ActionSpinStop]: false,
                [RouletteActions.ActionDouble]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionRebet]: !BetManager.hasPlacedBet() ? BetManager.hasLastBet() : false,
                [RouletteActions.ActionBetBack]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionBetReset]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionRacetrackNeighboursPlus]: Racetrack.hasNextNeighbourOption(),
                [RouletteActions.ActionRacetrackNeighboursMinus]: Racetrack.hasPreviousNeighbourOption(),
                [RouletteActions.ActionRacetrackToggle]: true,
                [RouletteActions.ActionSchemasDelete]: false,
                [RouletteActions.ActionSchemasPlayerSelect]: true,
                [RouletteActions.ActionSchemasDefaultSelect]: true,
                [RouletteActions.ActionSchemasSwitch]: true,
            });
        }

        HtmlController.updateActionElements(this.getAllActions());
    }

    private prepareJackpotMiniGame(): boolean {
        if (DataManager.GameRoundClosed && Jackpot.hasMiniGame() && !FreeRoundBonus.inFrb) {
            if (Jackpot.hasInitializedGame()) {
                DataManager.Autoplay = false;
                // this.resetWinAnimator();
                this.disable();
                FreeRoundBonus.disableUi();
                Jackpot.startMiniGame();

                return true;
            } else {
                const self = this;

                //in nogamble we need to wait for winCalculated finish to not run minigame right after machinestopped
                Jackpot.initMiniGame(true, () => {
                    // self.resetWinAnimator();
                    self.disable();
                    DataManager.Autoplay = false;
                    FreeRoundBonus.disableUi();
                });

                if (Jackpot.waitForMiniGameInitialization()) {
                    //in case we have limit, disable all actions during animation and wait for minigame
                    this.actions.disableAllActions();
                    HtmlController.updateActionElements(this.getAllActions());

                    return true;
                }
            }
        }

        return false;
    }

    private checkJackpotMiniGame(): boolean {
        if (!Jackpot.hasMiniGame()) {
            return false;
        }

        if (Jackpot.hasInitializedGame() || Jackpot.waitForMiniGameInitialization()) {
            if (GameManager.gameResponse.totalWin > 0) {
                this.changeWinBox();

                if (!DataManager.GameRoundClosed) {
                    this.collect(); //collect will call prepareNewGameRound
                } else {
                    //in nogamble gameround is closed, we need to update balance, if we have totalwin > 0
                    this.playCollectSound();
                    DataManager.updateDataElements();
                    this.prepareNewGameRound();
                }
            } else {
                this.prepareNewGameRound();
            }

            return true;
        } else {
            Jackpot.initMiniGame(false, null);
            Jackpot.disableMiniGameAutostart(); //if init was called from preparenewgameround

            return false;
        }
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    private clearTotalWin(): void {
        DataManager.updateDataElement(GameData.DataTotalWin, "0");
        DataManager.updateDataElement(GameData.DataTotalWinDenom, "0");
    }

    private getBetActionsWithState(state: boolean): { [action: string]: boolean } {
        let actions = {};

        for (let i = 0; i < this._betActions.length; i++) {
            actions[this._betActions[i]] = state;
        }

        return actions;
    }

    private getRacetrackActionsWithState(state: boolean): { [action: string]: boolean } {
        let actions = {};

        for (let i = 0; i < this._racetrackActions.length; i++) {
            actions[this._racetrackActions[i]] = state;
        }

        return actions;
    }

    private getChipSelectorActionsWithState(state: boolean): { [action: string]: boolean } {
        let actions = {};

        for (let i = 0; i < this._chipSelectorActions.length; i++) {
            actions[this._chipSelectorActions[i]] = state;
        }

        return actions;
    }

    private hasTableErrors(betPlaceId: string, customValue: number = -1): boolean {
        if (BetManager.betRestriction(betPlaceId)) {
            this.handleBetRestrictionError("toastMessageHolder");

            return true;
        }

        if (BetManager.reachedMaxTableLimit(customValue)) {
            this.handleMaxTableBetLimitError();

            return true;
        }

        if (BetManager.reachedSingleBetLimit(betPlaceId, customValue)) {
            this.handleSingleBetLimitError("toastMessageHolder");

            return true;
        }

        return false;
    }

    private handleMaxTableBetLimitError(): void {
        let elem = document.getElementById("maxTableLimit");

        if (elem != null) {
            elem.classList.remove("flash");
            elem.offsetWidth;
            elem.classList.add("flash");
        }

        HtmlToastMessage.show(
            Languages.getRid("ERROR_TABLE_LIMIT"),
            HtmlToastMessage.Position.middle,
            "singleGridBetPlaces",
        );
    }

    private handleMultipleSingleBetLimitError(): void {
        this.handleSingleBetLimitError("toastMessageHolder");
    }

    private handleSingleBetLimitError(betPlaceId: string): void {
        HtmlToastMessage.show(Languages.getRid("ERROR_BET_LIMIT"), HtmlToastMessage.Position.middle, betPlaceId);
    }

    private handleBetRestrictionError(betPlaceId: string): void {
        HtmlToastMessage.show(Languages.getRid("ERROR_OPPOSITE_BET"), HtmlToastMessage.Position.middle, betPlaceId);
    }

    private enableGameButtons(enable: boolean): void {
        let actions = {
            [RouletteActions.ActionAutoplay]:
                DataManager.GameRoundClosed && AppContext.gameConfiguration.AutoplayModeEnabled && enable,
            [RouletteActions.ActionDouble]: enable,
            [RouletteActions.ActionBetBack]: enable,
            [RouletteActions.ActionBetReset]: enable,
        };

        this.actions.changeActionStates(actions);
        HtmlController.updateActionElements(actions);
    }

    private updateSchemaButtons(schemaWithBetSelected: boolean, enableDelete: boolean = false): void {
        let actions = {
            [RouletteActions.ActionSchemasDelete]: schemaWithBetSelected && enableDelete,
        };

        this.actions.changeActionStates(this.getBetActionsWithState(!schemaWithBetSelected && !this._racetrackActive));
        this.actions.changeActionStates(this.getRacetrackActionsWithState(!schemaWithBetSelected));
        this.actions.changeActionStates(actions);

        HtmlController.updateActionElements(this.actions.getAllActions());
    }

    private updateTableCoverage(): void {
        let bets = BetManager.getPlacedBets();
        let betNumbers: Array<number> = [];
        for (let i = 0; i < bets.length; i++) {
            let numbers = BetManager.getBetNumbersByBetType(bets[i].type, bets[i].selection);
            for (let j = 0; j < numbers.length; j++) {
                if (betNumbers.indexOf(numbers[j]) == -1) {
                    betNumbers.push(numbers[j]);
                }
            }
        }

        let coverage = parseFloat(NumberUtils.multiply(NumberUtils.devide(betNumbers.length, 37), 100));

        DataManager.updateDataElement(GameData.DataTableCoverage, " " + coverage.toFixed(2) + "%");
    }

    limit(): void {
        LimitDialog.openDialog();

        this.actions.changeActionStates(this.getBetActionsWithState(true));
        this.actions.changeActionStates(this.getRacetrackActionsWithState(true));
        this.actions.changeActionStates(this.getChipSelectorActionsWithState(true));

        if (DataManager.GameRoundClosed) {
            this.actions.changeActionStates({
                [RouletteActions.ActionAutoplay]: AppContext.gameConfiguration.AutoplayModeEnabled,
                [RouletteActions.ActionAutoplayStop]: false,
                [RouletteActions.ActionSchemasToggle]: true,
                [RouletteActions.ActionStatisticsToggle]: true,
                [RouletteActions.ActionSpin]: true,
                [RouletteActions.ActionSpinStop]: false,
                [RouletteActions.ActionDouble]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionRebet]: !BetManager.hasPlacedBet() ? BetManager.hasLastBet() : false,
                [RouletteActions.ActionBetBack]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionBetReset]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionRacetrackNeighboursPlus]: Racetrack.hasNextNeighbourOption(),
                [RouletteActions.ActionRacetrackNeighboursMinus]: Racetrack.hasPreviousNeighbourOption(),
                [RouletteActions.ActionRacetrackToggle]: true,
                [RouletteActions.ActionSchemasDelete]: false,
                [RouletteActions.ActionSchemasPlayerSelect]: true,
                [RouletteActions.ActionSchemasDefaultSelect]: true,
                [RouletteActions.ActionSchemasSwitch]: true,
            });
        } else {
            this.actions.changeActionStates({
                [RouletteActions.ActionAutoplay]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionAutoplayStop]: false,
                [RouletteActions.ActionSchemasToggle]: true,
                [RouletteActions.ActionStatisticsToggle]: true,
                [RouletteActions.ActionSpin]: true,
                [RouletteActions.ActionSpinStop]: false,
                [RouletteActions.ActionDouble]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionRebet]: !BetManager.hasPlacedBet() ? BetManager.hasLastBet() : false,
                [RouletteActions.ActionBetBack]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionBetReset]: BetManager.hasPlacedBet(),
                [RouletteActions.ActionRacetrackNeighboursPlus]: Racetrack.hasNextNeighbourOption(),
                [RouletteActions.ActionRacetrackNeighboursMinus]: Racetrack.hasPreviousNeighbourOption(),
                [RouletteActions.ActionRacetrackToggle]: true,
                [RouletteActions.ActionSchemasDelete]: false,
                [RouletteActions.ActionSchemasPlayerSelect]: true,
                [RouletteActions.ActionSchemasDefaultSelect]: true,
                [RouletteActions.ActionSchemasSwitch]: true,
            });
        }
    }

    disable(): void {
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Mobile/MobileRouletteUserControls.ts
 **/